import React from "react";
import { getSeasonalTheme } from "@lib/seasonalTheme";
import "./SeriesAILogo.css";

const SeriesAILogo = ({ className = "", theme: themeOverride }) => {
  const theme = themeOverride || getSeasonalTheme();

  return (
    <span className={`seriesai-logo ${className}`.trim()} role="img" aria-label="Nougat">
      <img src={theme.mark} alt="" aria-hidden="true" />
      <span className="seriesai-logo-wordmark"><span>Nougat</span></span>
    </span>
  );
};

export default SeriesAILogo;

